import { populate } from 'populate';import dragonBones from 'pixi-dragonbones';

const raw = {
  className: 'SettingsMenuLayout',
  width: 640,
  height: 960,
  x: 0,
  y: 0,
  list: [
    {
      id: '79780dad-ff4b-4fee-a00c-cbc6eeb7dd7a',
      type: 'Container',
      name: 'root',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '',
      data: ''
    },
    {
      id: '892da9d8-d35d-40d8-9b45-5ff0532e66ab',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: -5,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'popup_background',
      parent: '79780dad-ff4b-4fee-a00c-cbc6eeb7dd7a',
      data: ''
    },
    {
      id: '21cf557c-dae3-4df0-8a14-7cfc5bc8afd2',
      type: 'Text',
      name: 'music_txt',
      nameSpace: '',
      className: '',
      x: -165,
      y: -20,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'On',
      localize: true,
      maxWidth: 120,
      maxHeight: 76,
      maxFontSize: 34,
      icons: [],
      style: {
        fontSize: 12,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#bb3e01',
        stroke: '#933019',
        strokeThickness: 0,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 0.9,
        dropShadowAngle: 1.8,
        dropShadowBlur: 0,
        dropShadowColor: '#b83500',
        dropShadowDistance: 3,
        leading: -15,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '79780dad-ff4b-4fee-a00c-cbc6eeb7dd7a',
      data: ''
    },
    {
      id: 'c6fe1b0c-ff41-49b7-8abd-c682cc354624',
      type: 'Text',
      name: 'sound_txt',
      nameSpace: '',
      className: '',
      x: 121,
      y: -20,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'On',
      localize: true,
      maxWidth: 120,
      maxHeight: 76,
      maxFontSize: 34,
      icons: [],
      style: {
        fontSize: 12,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#bb3e01',
        stroke: '#933019',
        strokeThickness: 0,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 0.9,
        dropShadowAngle: 1.8,
        dropShadowBlur: 0,
        dropShadowColor: '#b83500',
        dropShadowDistance: 3,
        leading: -15,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '79780dad-ff4b-4fee-a00c-cbc6eeb7dd7a',
      data: ''
    },
    {
      id: '98a02c5b-b071-4a8f-a6af-b86e18995509',
      type: 'Sprite',
      name: 'return_btn',
      nameSpace: 'returnbtn',
      className: '',
      x: 0,
      y: 310,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'button_medium_green',
      parent: '79780dad-ff4b-4fee-a00c-cbc6eeb7dd7a',
      data: ''
    },
    {
      id: '8f37b971-ae51-46c7-bfd9-add093934224',
      type: 'Sprite',
      name: 'exit_level_btn',
      nameSpace: 'exitlevelbtn',
      className: '',
      x: 0,
      y: 310,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'button_medium_red',
      parent: '79780dad-ff4b-4fee-a00c-cbc6eeb7dd7a',
      data: ''
    },
    {
      id: 'fec39824-120a-4e63-855f-fb22b6d8e156',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: -295,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'popup_title_bg',
      parent: '79780dad-ff4b-4fee-a00c-cbc6eeb7dd7a',
      data: ''
    },
    {
      id: 'ab6b723f-b1fb-4b15-a345-503760caadc8',
      type: 'Text',
      name: 'header_txt',
      nameSpace: '',
      className: '',
      x: 0,
      y: -300,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Settings',
      localize: true,
      maxWidth: 420,
      maxHeight: 78,
      maxFontSize: 44,
      icons: [],
      style: {
        fontSize: 29,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#ffffff',
        stroke: '#933019',
        strokeThickness: 4,
        align: 'center',
        wordWrap: true,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 0.9,
        dropShadowAngle: 1.8,
        dropShadowBlur: 0,
        dropShadowColor: '#b83500',
        dropShadowDistance: 3,
        leading: -15,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '79780dad-ff4b-4fee-a00c-cbc6eeb7dd7a',
      data: ''
    },
    {
      id: '8b7bbd41-8325-4a1b-b9f3-aa9637c91934',
      type: 'Text',
      name: 'music_title_txt',
      nameSpace: '',
      className: '',
      x: -160,
      y: -175,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'audioMusic',
      localize: true,
      maxWidth: 225,
      maxHeight: 80,
      maxFontSize: 40,
      icons: [],
      style: {
        fontSize: 14,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#ffffff',
        stroke: '#ab3145',
        strokeThickness: 6,
        align: 'center',
        wordWrap: true,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 0.9,
        dropShadowAngle: 1.8,
        dropShadowBlur: 0,
        dropShadowColor: '#ab3145',
        dropShadowDistance: 4,
        leading: -15,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '79780dad-ff4b-4fee-a00c-cbc6eeb7dd7a',
      data: ''
    },
    {
      id: '48d9d833-891c-4cd5-a8e7-aa60cf0f981b',
      type: 'Text',
      name: 'sound_title_txt',
      nameSpace: '',
      className: '',
      x: 128,
      y: -175,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'audioSfx',
      localize: true,
      maxWidth: 225,
      maxHeight: 80,
      maxFontSize: 40,
      icons: [],
      style: {
        fontSize: 14,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#ffffff',
        stroke: '#ab3145',
        strokeThickness: 6,
        align: 'center',
        wordWrap: true,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 0.9,
        dropShadowAngle: 1.8,
        dropShadowBlur: 0,
        dropShadowColor: '#ab3145',
        dropShadowDistance: 4,
        leading: -15,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '79780dad-ff4b-4fee-a00c-cbc6eeb7dd7a',
      data: ''
    },
    {
      id: 'af77e026-c166-4f2d-8551-13356e253cf1',
      type: 'Sprite',
      name: 'close_btn',
      nameSpace: '',
      className: '',
      x: 335,
      y: -246,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'button_close',
      parent: '79780dad-ff4b-4fee-a00c-cbc6eeb7dd7a',
      data: ''
    },
    {
      id: 'd005963a-4777-4cc4-825d-16013e4aa74a',
      type: 'Sprite',
      name: 'music_btn',
      nameSpace: '',
      className: '',
      x: -165,
      y: -90,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'audiomusic_1',
      parent: '79780dad-ff4b-4fee-a00c-cbc6eeb7dd7a',
      data: ''
    },
    {
      id: 'ee9d9d9f-4551-44ab-8bd6-d15ded7a24ac',
      type: 'Sprite',
      name: 'sound_btn',
      nameSpace: '',
      className: '',
      x: 121,
      y: -90,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'audiosfx_1',
      parent: '79780dad-ff4b-4fee-a00c-cbc6eeb7dd7a',
      data: ''
    },
    {
      id: '24e57d1f-edcd-4e88-8833-9b529020138f',
      type: 'Text',
      name: 'user_id_heading',
      nameSpace: '',
      className: '',
      x: 0,
      y: 140,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'UserId',
      localize: true,
      maxWidth: 345,
      maxHeight: 66,
      maxFontSize: 36,
      icons: [],
      style: {
        fontSize: 12,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#bb3e01',
        stroke: '#933019',
        strokeThickness: 0,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 0.9,
        dropShadowAngle: 1.8,
        dropShadowBlur: 0,
        dropShadowColor: '#b83500',
        dropShadowDistance: 3,
        leading: -15,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '79780dad-ff4b-4fee-a00c-cbc6eeb7dd7a',
      data: ''
    },
    {
      id: 'aa37041c-8484-4fe9-b828-e105a64572f3',
      type: 'Sprite',
      name: 'settings_bg',
      nameSpace: '',
      className: '',
      x: 0,
      y: 90,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'settingsidplace',
      parent: '79780dad-ff4b-4fee-a00c-cbc6eeb7dd7a',
      data: ''
    },
    {
      id: 'e037a902-27f4-44f9-be7e-b1add458e407',
      type: 'Text',
      name: 'user_id_txt',
      nameSpace: '',
      className: '',
      x: 0,
      y: 140,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'v2.121.0.0',
      localize: false,
      maxWidth: 310,
      maxHeight: 66,
      maxFontSize: 30,
      icons: [],
      style: {
        fontSize: 11,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#8a352a',
        stroke: '#8a352a',
        strokeThickness: 0,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 0.9,
        dropShadowAngle: 1.8,
        dropShadowBlur: 0,
        dropShadowColor: '#b83500',
        dropShadowDistance: 1,
        leading: -15,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '79780dad-ff4b-4fee-a00c-cbc6eeb7dd7a',
      data: ''
    },
    {
      id: 'e037a902-27f4-44f9-be7e-b2a63d38e407',
      type: 'Text',
      name: 'policy_txt',
      nameSpace: '',
      className: '',
      x: -150,
      y: 155,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'policy',
      localize: false,
      maxWidth: 310,
      maxHeight: 66,
      maxFontSize: 26,
      icons: [],
      style: {
        fontSize: 11,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#8a352a',
        stroke: '#8a352a',
        strokeThickness: 0,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 0.9,
        dropShadowAngle: 1.8,
        dropShadowBlur: 0,
        dropShadowColor: '#b83500',
        dropShadowDistance: 1,
        leading: -15,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '79780dad-ff4b-4fee-a00c-cbc6eeb7dd7a',
      data: ''
    },
    {
      id: 'e037a902-27f4-44f9-be7e-b1a63d58e407',
      type: 'Text',
      name: 'terms_txt',
      nameSpace: '',
      className: '',
      x: 150,
      y: 155,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'terms',
      localize: false,
      maxWidth: 310,
      maxHeight: 66,
      maxFontSize: 26,
      icons: [],
      style: {
        fontSize: 11,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#8a352a',
        stroke: '#8a352a',
        strokeThickness: 0,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 0.9,
        dropShadowAngle: 1.8,
        dropShadowBlur: 0,
        dropShadowColor: '#b83500',
        dropShadowDistance: 1,
        leading: -15,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '79780dad-ff4b-4fee-a00c-cbc6eeb7dd7a',
      data: ''
    },
    {
      id: 'e037a902-27f4-44f9-be7e-b1add453f507',
      type: 'Text',
      name: 'contact_txt',
      nameSpace: '',
      className: '',
      x: 0,
      y: 200,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'contact',
      localize: false,
      maxWidth: 310,
      maxHeight: 66,
      maxFontSize: 26,
      icons: [],
      style: {
        fontSize: 11,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#8a352a',
        stroke: '#8a352a',
        strokeThickness: 0,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 0.9,
        dropShadowAngle: 1.8,
        dropShadowBlur: 0,
        dropShadowColor: '#b83500',
        dropShadowDistance: 1,
        leading: -15,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '79780dad-ff4b-4fee-a00c-cbc6eeb7dd7a',
      data: ''
    },
    {
      id: 'c409718f-3d24-4103-bcdd-a25093f6ee53',
      type: 'Text',
      name: 'version_txt',
      nameSpace: '',
      className: '',
      x: -285,
      y: -250,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Version',
      localize: true,
      maxWidth: 389,
      maxHeight: 66,
      maxFontSize: 20,
      icons: [],
      style: {
        fontSize: 12,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#bb3b2f',
        stroke: '#bb3b2f',
        strokeThickness: 0,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 0.9,
        dropShadowAngle: 1.8,
        dropShadowBlur: 0,
        dropShadowColor: '#b83500',
        dropShadowDistance: 3,
        leading: -15,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '79780dad-ff4b-4fee-a00c-cbc6eeb7dd7a',
      data: ''
    },
    {
      id: 'acde098a-79b2-4995-8a11-3eef1def8e92',
      type: 'Text',
      name: 'return',
      nameSpace: '',
      className: '',
      x: 0,
      y: -6,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Return',
      localize: true,
      maxWidth: 215,
      maxHeight: 70,
      maxFontSize: 51,
      icons: [],
      style: {
        fontSize: 51,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#ffffff',
        stroke: '#074829',
        strokeThickness: 6,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '98a02c5b-b071-4a8f-a6af-b86e18995509',
      data: ''
    },
    {
      id: 'e177d09b-3f5c-42c1-a202-7d61ca6ebab8',
      type: 'Text',
      name: 'exit_level_txt',
      nameSpace: 'exitleveltxt',
      className: '',
      x: 0,
      y: -6,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'EndLevelCaps',
      localize: true,
      maxWidth: 175,
      maxHeight: 73,
      maxFontSize: 51,
      icons: [],
      style: {
        fontSize: 51,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#ffffff',
        stroke: '#81242c',
        strokeThickness: 6,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 140,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '8f37b971-ae51-46c7-bfd9-add093934224',
      data: ''
    }
  ],
  version: '1.0.x'
} as const;

export class SettingsMenuLayout {
  static raw = raw;
  root: PIXI.Container
  music_txt: PIXI.Text
  sound_txt: PIXI.Text
  return_btn: PIXI.Sprite
  exit_level_btn: PIXI.Sprite
  header_txt: PIXI.Text
  music_title_txt: PIXI.Text
  sound_title_txt: PIXI.Text
  close_btn: PIXI.Sprite
  music_btn: PIXI.Sprite
  sound_btn: PIXI.Sprite
  user_id_heading: PIXI.Text
  settings_bg: PIXI.Sprite
  user_id_txt: PIXI.Text
  version_txt: PIXI.Text
  policy_txt: PIXI.Text
  terms_txt: PIXI.Text
  contact_txt: PIXI.Text

  returnbtn: {
    return: PIXI.Text
    children: (PIXI.Text)[]
  }
  exitlevelbtn: {
    exit_level_txt: PIXI.Text
    exitleveltxt: {}
    children: (PIXI.Text)[]
  }

  constructor() {
    populate(this, raw);
  }
}
